export const COLORS = ['orange', 'magenta', 'purple', 'geekblue', 'green', 'red', 'volcano', 'gold', 'lime', 'cyan', 'blue']
export type PinColorType = typeof COLORS[number]
